module.exports = __webpack_public_path__ + "static/media/manufacture.93912869.png";